module.exports = __webpack_public_path__ + "img/productSatellite_13.65307c5c.png";